import React, { useEffect, useRef, useState } from 'react';
import { FaChevronDown, FaSearch, FaTimes } from 'react-icons/fa';

const FilterDropdown = ({ label, value, options, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={`stm-filter-dropdown ${value ? 'has-value' : ''}`} ref={ref}>
      <button type="button" className="stm-filter-dropdown__trigger" onClick={() => setIsOpen((prev) => !prev)}>
        {value || label}
        <FaChevronDown />
      </button>
      {isOpen && (
        <div className="stm-filter-dropdown__menu">
          <button type="button" className={!value ? 'is-active' : ''} onClick={() => { onChange(''); setIsOpen(false); }}>
            {placeholder}
          </button>
          {options.map((option) => (
            <button
              key={option}
              type="button"
              className={value === option ? 'is-active' : ''}
              onClick={() => { onChange(option); setIsOpen(false); }}
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const TenantToolbar = ({
  searchTerm,
  filters,
  labelOptions,
  statusOptions,
  activeChips,
  onSearchChange,
  onFilterChange,
  onRemoveChip,
  onClearFilters,
}) => {
  const hasActiveFilters = activeChips.length > 0;

  return (
    <div className="stm-toolbar">
      <div className="stm-toolbar__row">
        <div className="stm-search">
          <FaSearch className="stm-search__icon" aria-hidden />
          <input
            className="stm-search__input"
            value={searchTerm}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search tenants..."
            aria-label="Search tenants"
          />
        </div>
        <FilterDropdown
          label="Status"
          value={filters.status}
          options={statusOptions}
          placeholder="All statuses"
          onChange={(value) => onFilterChange('status', value)}
        />
        <FilterDropdown
          label="Labels"
          value={filters.label}
          options={labelOptions}
          placeholder="All labels"
          onChange={(value) => onFilterChange('label', value)}
        />
        {hasActiveFilters && (
          <button type="button" className="stm-clear-filters" onClick={onClearFilters}>
            Clear filters
          </button>
        )}
      </div>
      {hasActiveFilters && (
        <div className="stm-filter-chips">
          {activeChips.map((chip) => (
            <button key={chip.key} type="button" className="stm-filter-chip" onClick={() => onRemoveChip(chip.key)}>
              {chip.label}
              <FaTimes aria-hidden />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TenantToolbar;
